import React from "react";
import i18n from "@microdoing/shared/i18n";
import LottieCheckDone from "../../Lotties/LottieCheckDone";
import { useSelector } from "react-redux";
import { Box, MainText, MainTitle } from "app/components/common";

const FinishedCampaign = ({}) => {
  const firstName = useSelector(state => state.user.firstName);

  return (
    <Box
      flex={1}
      display="flex"
      alignItems="center"
      justifyContent="space-around"
      flexDirection="column"
    >
      <MainTitle variant="l8-bold" textAlign="center" width={"80%"}>
        {i18n.t("end-session", { firstName })}
      </MainTitle>

      <Box alignItems="center" justifyContent="center">
        <LottieCheckDone />
      </Box>
      <MainText
        variant="l4-medium"
        color="neutral.900"
        textAlign="center"
        width="80%"
      >
        {i18n.t("see-you-next-campaign")}
      </MainText>
    </Box>
  );
};

export default FinishedCampaign;
